module.exports = __webpack_public_path__ + "static/pensjonat-glowne-photo02-af961015dfd2f00dbbbc432b780d12f2.jpg";